<template>
  <base-card class="px-3 pt-2">
    <div class="px-2 py-1">
      <base-heading>Email Performance</base-heading>
      <hr style="border-color: #D4D4D4">
      <template v-if="loading">
        <base-skeleton class="row">
          <div
            v-for="n in 3"
            :key="n"
            class="text-center col-4 px-2"
          >
            <div class="my-4">
              <div
                class="skeleton__item ml-auto mr-auto"
                style="max-width: 25px"
              />
              <div
                class="skeleton__item mb-3"
                style="height:140px; width: 100%;"
              />
              <div
                class="skeleton__item ml-auto mr-auto"
                style="max-width: 60%"
              />
              <div
                class="skeleton__item ml-auto mr-auto"
                style="max-width: 80%"
              />
            </div>
          </div>
        </base-skeleton>
      </template>
      <template v-else>
        <sales-summary-chart
          class="chart mt-n3 mx-n3"
          :chartdata="chartData"
          :labels="labels"
          :height="306"
          :options="chartOptions"
          :label-size="responsiveLabelSize"
          title=""
        />
      </template>
    </div>
  </base-card>
</template>
<script>
import SalesSummaryChart from '@/components/Widgets/Reports/SalesSummaryChart';

export default {
  name: 'AssociatePerformanceChartContainer',
  components: {
    SalesSummaryChart,
  },
  props: {
    dataRange: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      responsiveLabelSize: 10,
    };
  },
  computed: {
    chartData() {
      return [{
        name: 'Open Rate',
        values: this.chartValues.map((value) => (this.getRate(value))),
      }];
    },
    chartValues() {
      return [this.stats.open_rate, this.stats.ctr, this.stats.unsubscribe_rate];
    },
    labels() {
      return [
        ['Average', 'Open Rate'],
        ['Average', 'Click-Through Rate'],
        ['Average', 'Unsub. Rate'],
      ];
    },
    stats() {
      // Retrieved by AssociateActivityContainer
      const stats = this.$store.state.profiles.itemStats;
      return stats || {};
    },
    loading() {
      return this.$store.state.profiles.itemStatsLoading;
    },
    chartOptions() {
      return {
        dataLabelsFontSize: 15,
      };
    },
  },
  mounted() {
    this.mediaQuery();
  },
  methods: {
    mediaQuery() {
      /* This method mimics CSS mediaqueries but in JS.
      Required to pass variables to ChartJS */

      const mediaQuery = window.matchMedia('(min-width: 1000px)');
      const sizes = {
        small: 10, // This is an arbitrary size that fixes into ipad size
        regular: 15, // Defined by design team
      };
      const resize = (mq) => {
        this.responsiveLabelSize = (mq.matches) ? sizes.regular : sizes.small;
      };
      resize(mediaQuery); // Initial call
      mediaQuery.addEventListener('change', (mq) => resize(mq)); // Listening to changes
    },
    getRate(rate) {
      return rate > 0 ? rate : 0;
    },
  },
};
</script>
<style lang="scss"
  scoped>
::v-deep .chart.sl-card {
  .card-body {
    padding: 0;
  }
}
</style>
